<template>
    <div>
    <app-toolbarcustom app_title="Data Surat Perintah Transfer" app_menu="hrspt"></app-toolbarcustom>
        <v-progress-linear
        indeterminate
        color="fourth"
        rounded
        v-if="loading.page"
        class="progress-fixed"
        ></v-progress-linear>
        <div class="mb-15"></div>
        <v-text-field
            v-model="search"
            label="Cari No Surat atau Subjek"
            prepend-inner-icon="mdi-magnify"
            clearable
            class="mx-4"
            />
            <div class="d-flex justify-center mb-4">
            <v-btn-toggle
                v-model="statusfilter"
                class="mx-4 mb-4"
                mandatory
                rounded
                dense
                >
                <v-btn value="ALL">All</v-btn>
                <v-btn value="R">Pending Leader</v-btn>
                <v-btn value="F">Pending Finance</v-btn>
                <v-btn value="P">Paid</v-btn>
            </v-btn-toggle>
            </div>
        <v-card
            class="mx-auto mb-2"
            max-width="344"
            outlined
            v-for="row in filteredPosts"
            :key="row.letter_id"
            @click="GoTo(row.letter_id)"
        >
            <v-list-item three-line>
            <v-list-item-content>
                <div class="text-overline mb-4">
                {{ $functions.FormatDateIndoWithDayName(row.letter_date) }}
                </div>
                <v-list-item-title>{{row.letter_id}}</v-list-item-title>
                <v-list-item-subtitle>{{row.letter_subject}} {{row.letter_key.toUpperCase()}}</v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-avatar
                size="80"
                color="secondary"
                class="white--text title d-flex align-center justify-center"
            >
            <span class="font-weight-bold text-h5">
                {{ $functions.NewFormatNumber(row.letter_count) }}
            </span>
            </v-list-item-avatar>
            </v-list-item>

            <v-card-actions>
            <small class="ml-2"><v-icon>money</v-icon> IDR {{ $functions.NewFormatNumber(row.letter_total) }}</small><v-spacer></v-spacer><small><v-chip
                class="ma-2"
                color="primary"
                label
                text-color="white"
              >
                <v-icon left>
                  mdi-label
                </v-icon>
                {{ row.letter_status_desc }}
              </v-chip></small>
            </v-card-actions>
        </v-card>
        <infinite-loading @infinite="ListInfinite" v-if="posts.length >= pages.limit && statusfilter === 'ALL'"></infinite-loading>
        <div class="mb-15"></div>
        <v-dialog v-model="confirm.dialog" max-width="490" persistent>
            <v-card>
                <v-card-title class="secondary headline white--text">{{confirm.title}}</v-card-title>
                <v-card-text>
                    {{confirm.text}}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" outlined @click.stop="confirm.dialog = false">{{confirm.close}}</v-btn>
                    <v-btn id="dialog_confirm_true" color="primary" outlined :disabled = "confirm.ok !== 'OK' ? true:false" @click="Loading">{{confirm.ok}}</v-btn>
                </v-card-actions>
            </v-card>
          </v-dialog>
        <app-snackbar 
            :dialog="snackbar.dialog"
            :color="snackbar.color"
            :text="snackbar.text"
            :timeout="snackbar.timeout"
            @close="snackbar.dialog = false"
          ></app-snackbar>
    </div>
</template>
<script>
    export default {
        data: () => ({
            statusfilter: 'F',
            search: '',
            posts:[],
            loading: {
                page: false
            },
            pages: {
                limit:10,
                offset:10,
                fetch:10,
            },
            confirm: {
                dialog: false,
                title: '',
                text: '',
                ok: 'OK',
                close: 'Tutup',
            },
            snackbar: {
                dialog: false,
                timeout: 3000,
                text: '',
                color: 'error'
            }
        }),
        computed: {
            filteredPosts() {
                const keyword = this.search.toLowerCase().trim()

                return this.posts.filter(row => {
                const matchSearch =
                    row.letter_id.toLowerCase().includes(keyword) ||
                    row.letter_subject.toLowerCase().includes(keyword)

                const matchStatus =
                    this.statusfilter === 'ALL' || row.letter_status === this.statusfilter

                return matchSearch && matchStatus
                })
            },
        },
        created() {
            this.FirstLoad()
        },
        methods: {
            ListInfinite($state) {
                let pending = ''
                if (this.$route.query.pending !== undefined && this.$functions.UsersType() !== 'HR-MGR') {
                    pending = this.$route.query.pending
                }
                let formdata = {
                  letter_type: 'SPT',
                  letter_pending: pending,
                  order_by: 'letter_cdate',
                  order_type: 'DESC',
                  offset: this.$functions.ConvNom(this.pages.offset),
                  fetch: this.$functions.ConvNom(this.pages.fetch),
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiListLetter'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(({data}) => {
                    if (data.length) {
                        this.pages.offset = this.pages.offset + this.pages.fetch
                        this.posts.push(...data)
                        $state.loaded()
                    } else {
                        $state.complete()
                    }
                })
            },
            FirstLoad () {
                this.loading.page = true
                let pending = ''
                if (this.$route.query.pending !== undefined && this.$functions.UsersType() !== 'HR-MGR') {
                    pending = this.$route.query.pending
                }
                let formdata = {
                  letter_type: 'SPT',
                  letter_pending: pending,
                  order_by: 'letter_cdate',
                  order_type: 'DESC',
                  limit: this.$functions.ConvNom(this.pages.limit),
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiListLetter'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        this.posts = feedback
                    } else {
                        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 3000)
                    }
                    this.loading.page = false
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                    this.loading.page = false
                })
            },
            GoTo (id) {
                this.$router.push({name: 'hrsptdetail',params:{id:this.$functions.EncodeUrl(id)}})
            },
            Loading () {
                this.confirm.ok = 'Loading...'
            },
            SnackBar (dialog, color, text, timeout) {
                this.snackbar = {
                    dialog: dialog,
                    color: color,
                    text: text,
                    timeout: timeout
                }
                if (color === 'error') {
                    this.confirm.dialog 	 = false
                    this.confirm.ok 	 	 = 'OK'
                }
            }
        }
    }
</script>